import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-personal-pricing',
  templateUrl: './personal-pricing.component.html',
  styleUrls: ['./personal-pricing.component.scss']
})
export class PersonalPricingComponent implements OnInit {

  constructor(
    public navigationService: NavigationService
  ) { }

  ngOnInit() {
  }

}
